import { Journey } from '../Types/journey';
import { get } from './common';

const journeyEndpoint = 'api/engage';

export async function getEngageJourneys(): Promise<Journey[]> {
	const endpoint = `${journeyEndpoint}/GetEngageJourneys?deepload=true`;
	const result = await get<Journey[]>(endpoint);
	return result ?? [];
}
